import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import React from 'react';

import { MosPosMenuSummary } from '@/services/MosPosMenuMaster';

type Props = {
  summary: MosPosMenuSummary;
};

const cards = (summary: MosPosMenuSummary) => [
  { label: '登録済み親商品（ルート）', value: summary.registered_count },
  { label: '子商品リレーション', value: summary.relation_count },
  { label: '販売開始前', value: summary.prepare_count, color: '#975A16' },
  { label: '販売中', value: summary.active_count, color: '#276749' },
  { label: '販売終了', value: summary.ended_count, color: '#718096' },
];

/** SCR009 のサマリカード。値は全て API の集計をそのまま表示します。 */
export const SummaryCards: React.FC<Props> = ({ summary }) => (
  <SimpleGrid
    columns={{ base: 2, md: 5 }}
    spacing={3.5}
    data-testid="summary-grid"
    data-desktop-columns="5"
  >
    {cards(summary).map((card) => (
      <Box
        key={card.label}
        borderWidth="1px"
        borderRadius="5px"
        px={4}
        py={3.5}
        bg="white"
        boxShadow="0 1px 2px rgba(45,55,72,0.04)"
      >
        <Text fontSize="xs" color="gray.500">
          {card.label}
        </Text>
        <Text
          fontSize="2xl"
          fontWeight="bold"
          color={card.color}
          data-testid={`summary-${card.label}`}
        >
          {card.value}
          <Text as="span" fontSize="xs" fontWeight="normal" ml={1}>
            件
          </Text>
        </Text>
      </Box>
    ))}
  </SimpleGrid>
);
